import { labelsArr, responseLabelsArr } from '../../../libs/arrEvalDirectManager';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

import './directManagerEvalStatPopup.scss'

export default function DirectManagerEvalStatPopup({data,firstWord}) {

    const handleShowData = ()=>{
        return (
         <>
         {
            responseLabelsArr.map((item,index)=>(
            <div className='DirectManagerEvalStatPopup_item_value' key={index}>
              <span dir='rtl' style={{color:"#3b82f6"}}>{index+1}-</span>
              <span dir='rtl'>{labelsArr[index]} : </span>
              <span dir='rtl'>{data[item] ? Math.round(data[item]) : ""}</span>   
            </div>
            ))
         }
         </>
         ) }


    return (
        <div>
          
            <Popup trigger=
                {  <span className='text_inPopUp' dir='rtl'>{firstWord}</span>}
                position="bottom center"
                on={['hover']} // Set the trigger to hover
                closeOnDocumentClick
                mouseEnterDelay={100} // Optional: Adds a slight delay before showing the popup
                mouseLeaveDelay={100} // Optional: Adds a slight delay before hiding the popup
                >
                <div className='DirectManagerEvalStatPopup_div_container' dir='rtl'>
                 <div className='DirectManagerEvalStatPopup_items'>
                    {handleShowData()}
                </div>   
                </div>
            </Popup>
        </div>
    )
};